import React from 'react'
import {change as changeFieldValue, Field, formValueSelector, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {
  alterarMotorista,
  buscarMotorista,
  cadastrarMotorista,
  excluirMotorista
} from '../../../actions/motorista/motoristaActions';
import {renderFieldDataNascimento, required, requiredSelect, renderFieldNumeros} from '../../../util/inputs';
import {renderField} from '../../../util/arraysUtil';
import Estados from '../../comum/Estados';
import $ from 'jquery';
import CategoriaCNH from '../../comum/CategoriaCNH';
import {showSuccessMsg} from '../../../util/messagesUtil';


export class ModalCadastrarMotorista extends React.Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
    }

    handleEstado() {}

    exibirComboEstado(event) {
        return <Estados event={event} handleEstado={this.handleEstado.bind(this)}/>

    }

    exibirComboCategoriaCNH(event) {
        return <CategoriaCNH event={event}/>

    }

    cadastrar(motorista) {
        this.props.cadastrarMotorista(motorista, this.props.empresaSelecionada.id)
            .then(() => {
                showSuccessMsg('Motorista cadastrado com sucesso');
            })
    }

    alterar(motorista) {
        this.props.alterarMotorista(motorista, this.props.empresaSelecionada.id)
            .then(() => {
                showSuccessMsg('Motorista alterado com sucesso');
            })
    }

    limparFormulario() {
        this.props.changeFieldValue('formCadastrarMotorista',
            'numeroRegistroCNH', '');
        this.props.changeFieldValue('formCadastrarMotorista',
            'categoriaCNH', '');
        this.props.changeFieldValue('formCadastrarMotorista',
            'docIdentidadeEmissor', '');
        this.props.changeFieldValue('formCadastrarMotorista',
            'estadoEmissao', '');
        this.props.changeFieldValue('formCadastrarMotorista',
            'validadeCNH', '');
        this.props.changeFieldValue('formCadastrarMotorista',
            'validadeRegistroANTT', '');
        this.props.changeFieldValue('formCadastrarMotorista',
            'numeroRegistroANTT', '');
        this.props.changeFieldValue('formCadastrarMotorista',
            'idMotorista', null);
    }

    excluirMotorista(codigoEmpresa, codigoMotorista) {
        this.props.excluirMotorista(codigoEmpresa, codigoMotorista).then(() => {
              showSuccessMsg('Motorista excluído com sucesso');
        })
        this.limparFormulario();
    }

    fecharModal() {
        $('#formCadastrarMotorista')
            .modal('hide');
        $('#formCadastrarMotorista')
            .hide();
        $('.modal-backdrop')
            .hide();
        this.props.reset('formCadastrarMotorista')
    }

    submit(values) {
        const dadosMotorista = {
            id: values.idMotorista,
            numeroRegistroCNH: values.numeroRegistroCNH,
            validadeCNH: values.validadeCNH,
            categoriaCNH: values.categoriaCNH.value,
            uf: values.estadoEmissao.value,
            docIdentidadeEmissor: values.docIdentidadeEmissor,
            numeroRegistroANTT: values.numeroRegistroANTT,
            validadeRegistroANTT: values.validadeRegistroANTT,
            codigoUsuarioEmpresa: this.props.usuarioSelecionado.usuarioEmpresaId
        }
        if (values.idMotorista) {
            this.alterar(dadosMotorista)
        } else {
            this.cadastrar(dadosMotorista)
        }
    }

    render() {
        const { handleSubmit, submitting, invalid, pristine } = this.props;
        return (
            <div className="modal fade show" id='modalCadastrarMotorista' role='dialog'
                aria-labelledby='modalCadastrarMotorista' aria-hidden='true' data-backdrop='static'>
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content vx-modal-content">

                        {/* Header */}
                        <div className="vx-modal-header">
                            <div className="vx-modal-header-icon">
                                <i className="material-icons">badge</i>
                            </div>
                            <div>
                                <h5 className="vx-modal-title">
                                    {this.props.idMotorista ? 'Editar motorista' : 'Cadastro de motorista'}
                                </h5>
                            </div>
                            <button type="button" className="vx-modal-close" data-dismiss="modal"
                                aria-label="Close" onClick={() => this.limparFormulario()}>
                                <i className="material-icons">close</i>
                            </button>
                        </div>

                        {/* Body */}
                        <div className="vx-modal-body">
                            <form onSubmit={handleSubmit(this.submit)}>

                                {/* CNH */}
                                <div className="vx-config-section-title">
                                    <i className="material-icons">credit_card</i>
                                    CNH
                                </div>
                                <div className="form-row">
                                    <div className="col-12 col-sm-5 col-md-5">
                                        <Field name="numeroRegistroCNH" type="text" required={true}
                                            component={renderFieldNumeros}
                                            validate={[required]}
                                            label="Nº registro CNH"
                                            css="form-control" />
                                    </div>
                                    <div className="col-12 col-sm-3 col-md-3">
                                        <Field name="validadeCNH" type="text" required={true}
                                            component={renderFieldDataNascimento}
                                            validate={[required]}
                                            css="form-control" label="Validade da CNH" />
                                    </div>
                                    <div className="col-12 col-sm-4 col-md-4">
                                        <label className="mt-2">Categoria da CNH</label>
                                        <Field name='categoriaCNH' validate={[requiredSelect]}
                                            component={this.exibirComboCategoriaCNH.bind(this)} />
                                    </div>
                                </div>

                                {/* Habilitação */}
                                <div className="vx-config-section-title mt-4">
                                    <i className="material-icons">assignment_ind</i>
                                    Habilitação
                                </div>
                                <div className="form-row">
                                    <div className="col-12 col-sm-6 col-md-6">
                                        <Field name="docIdentidadeEmissor" type="text" required={true}
                                            component={renderField}
                                            validate={[required]}
                                            label="Doc. identidade emissor"
                                            css="form-control" />
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-6">
                                        <label className="mt-2">Estado de emissão</label>
                                        <Field name='estadoEmissao' label="Estado"
                                            validate={[requiredSelect]}
                                            component={this.exibirComboEstado.bind(this)} />
                                    </div>
                                </div>

                                {/* ANTT */}
                                <div className="vx-config-section-title mt-4">
                                    <i className="material-icons">local_shipping</i>
                                    ANTT
                                </div>
                                <div className="form-row">
                                    <div className="col-12 col-sm-6 col-md-6">
                                        <Field name="numeroRegistroANTT" type="text" required={true}
                                            component={renderFieldNumeros}
                                            validate={[required]}
                                            label="Nº registro ANTT"
                                            css="form-control" />
                                    </div>
                                    <div className="col-12 col-sm-4 col-md-4">
                                        <Field name="validadeRegistroANTT" type="text" required={true}
                                            component={renderFieldDataNascimento}
                                            validate={[required]}
                                            css="form-control" label="Validade do registro ANTT" />
                                    </div>
                                </div>

                                <Field name="idMotorista" type="hidden" component={renderField}
                                    css="form-control col-md-12" />

                                {/* Footer */}
                                <div className="vx-modal-footer">
                                    <button type="submit"
                                        disabled={invalid || submitting || pristine}
                                        className="vx-btn-primary">
                                        <i className="material-icons">
                                            {this.props.idMotorista ? 'save' : 'add'}
                                        </i>
                                        {this.props.idMotorista ? 'Salvar alterações' : 'Cadastrar'}
                                    </button>
                                    {this.props.idMotorista && (
                                        <button type="button"
                                            onClick={() => this.excluirMotorista(this.props.empresaSelecionada.id, this.props.idMotorista)}
                                            data-dismiss="modal"
                                            className="vx-btn-danger">
                                            <i className="material-icons">delete</i>
                                            Excluir
                                        </button>
                                    )}
                                </div>
                            </form>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        idMotorista: formValueSelector('formCadastrarMotorista')(state, 'idMotorista'),
        empresaSelecionada: state.empresaSelecionada,
        usuarioSelecionado: state.usuarioSelecionado
    }
}


export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        changeFieldValue,
        cadastrarMotorista,
        alterarMotorista,
        buscarMotorista,
        excluirMotorista
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formCadastrarMotorista'
})(ModalCadastrarMotorista));
